import React, {useState, useEffect, useContext} from "react";
import Table from "../../../components/table/Tables";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import ShowCourseModal from "./ShowModal";
import DeleteModal from "../../../components/modals/DeleteModal";
import {EssentialContext} from "../../../context/EssentialProvider";
import {useHistory} from "react-router-dom";
import {DeleteCourse} from "../../../services/CoursesServices";
import {PageWebUrl} from "../../../services/ApiUrl";

export default function CoursesList({theme, isLoading, data, toggleChange}) {
   const {removeCourse} = useContext(EssentialContext);
   const [showModal, setShowModal] = useState({isOpen: false, data: {}});
   const [deleteModal, setDeleteModal] = useState({isOpen: false, id: "", url: ""});
   const {getAllCourses, essentialList} = useContext(EssentialContext);
   const [isSaving, setSaving] = useState(false);

   let history = useHistory();

   useEffect(() => {
      getAllCourses();
   }, []);

   const saveDelete = () => {
      setSaving(true);
      DeleteCourse(deleteModal.id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // const newList = essentialList.filter((course) => course.idCourse !== id);
            removeCourse(deleteModal.id);
         })
         .then(() => {
            setSaving(false);
            setDeleteModal({isOpen: false, id: "", url: ""});
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   return (
      <>
         {isLoading ? (
            <LoadComponet isVisible={true} theme={theme} />
         ) : (
            <Table
               theme={theme}
               data={essentialList}
               toggleChange={toggleChange}
               showModal={(toShow) => {
                  let info = essentialList.find((item) => item.idCourse === toShow.idCourse);
                  console.log(info);
                  setShowModal({isOpen: true, data: info, type: "info", title: "Información De curso esencial"});
               }}
               deleteModal={(toShow) => {
                  setDeleteModal({isOpen: true, id: toShow.idCourse, url: "google.com"});
               }}
               viewAction={(item) => {
                  let newxtUrl = PageWebUrl + "cursos_esenciales/" + item.idCourse;
                  window.open(newxtUrl, "_blank");
               }}
               columns={Columns}
               editModal={(item) => {
                  // console.log(item);
                  history.push(`/offer/edit/${item.idCourseType}/${item.idCourse}`, {prev: "/offer/cursos_esenciales"});
               }}
            />
         )}
         <ShowCourseModal
            isOpen={showModal.isOpen}
            close={() => {
               setShowModal(false);
            }}
            theme={theme}
            type={showModal.type}
            title={showModal.title}
            data={showModal.data}
         />
         <DeleteModal
            isOpen={deleteModal.isOpen}
            close={() => {
               setDeleteModal({isOpen: false, data: {}, id: "", url: ""});
            }}
            id={deleteModal.id}
            url={deleteModal.url}
            theme={theme}
            confirm={saveDelete}
            //, save, id, url
         />
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const Columns = [
   {
      title: "Nombre",
      accessor: "courseName",
      action: "show",
   },
   {
      title: "Facilitadores",
      accessor: "facilitator",
   },
   {
      title: "Código de curso",
      accessor: "courseCode",
   },
   {
      title: "Fecha de inicio",
      accessor: "startDate",
   },
   {
      title: "Añadir a la página",
      class: "actionBtn ghost",
      component: "toggle",
      accessor: "visible",
   },
   {
      title: "Vista en página",
      class: "actionBtn ghost",
      component: "view",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "show",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "edit",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];
